import bibme from './bibme'
import citationmachine from './citationmachine'
import easybib from './easybib'

const sites = {
  bibme,
  citationmachine,
  easybib,
}

const getWidgetProps = ({ site, ...rest }) => {
  if (!sites[site]) {
    throw new Error(
      `Invalid site property passed to upload-widget: '${site}'.\nSelect a valid site name: [${Object.keys(sites).join(
        ', '
      )}]`
    )
  }

  return sites[site](rest)
}

export default getWidgetProps
